import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { TableHeaders } from 'components/table/private/TableHeaders';
import { TableRow } from 'components/table/private/TableRow';
import './TableHead.scss';
/**
 * @component TableHead
 * @since 1.0.0
 * @hidden
 */
export function TableHead(props) {
    const { style, schema } = Object.assign({ style: 'normal' }, props);
    const className = classNames('table-head', 'table-head--' + style);
    return (React.createElement("thead", { className: className },
        React.createElement(TableRow, null,
            React.createElement(TableHeaders, { schema: schema }))));
}
